import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import HomePage from './pages/home/HomePage';
import HomePageBackup from './pages/home/HomePageBackup';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import MatchVote from './pages/matches/MatchVote';
import MatchDetails from './pages/matches/MatchDetails';
import SportsGames from './pages/games/SportsGames';
import DrawGame from './pages/games/DrawGame';
import DailyQuiz from './pages/games/DailyQuiz';
import Leaderboard from './pages/leaderboard/Leaderboard';
import BuySellPage from './pages/games/BuySellPage';
import SellSellSell from './pages/games/SellSellSell';
import PlayerReview from './pages/players/PlayerReview';
import PlayerDetail from './pages/players/PlayerDetail';
import SoundBoard from './pages/games/SoundBoard';
import OnThisDay from './pages/games/OnThisDay';
import SpectatorSeating from './pages/spectator/SpectatorSeating';
import CountryBattle from './pages/games/CountryBattle';
import FunDilemma from './pages/games/FunDilemma';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home-backup" element={<HomePageBackup />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/match-vote" element={<MatchVote />} />
          <Route path="/match/:matchId" element={<MatchDetails />} />
          <Route path="/sports-games" element={<SportsGames />} />
          <Route path="/draw-game" element={<DrawGame />} />
          <Route path="/daily-quiz" element={<DailyQuiz />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/buy-sell" element={<BuySellPage />} />
          <Route path="/sell-sell-sell" element={<SellSellSell />} />
          <Route path="/player-review" element={<PlayerReview />} />
                  <Route path="/player-detail/:id" element={<PlayerDetail />} />
                   <Route path="/sports-craft" element={<SoundBoard />} />
                           <Route path="/on-this-day" element={<OnThisDay />} />
          <Route path="/mystery-sports-legend" element={<SpectatorSeating />} />
          <Route path="/spectator-seating" element={<SpectatorSeating />} />
          <Route path="/spectator-seating-2" element={<SpectatorSeating />} />
          <Route path="/country-battle" element={<CountryBattle />} />
          <Route path="/fun-dilemma" element={<FunDilemma />} />

        </Routes>
      </div>
    </Router>
  );
}

export default App;
